$(document).ready(function() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");

  window.addEventListener("resize", function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
  });

  $(window).on('scroll',function () {
      if($(this).scrollTop() > 50) {
          $('.page-header').addClass('page-header--scrolled');
      } else {
          $('.page-header').removeClass('page-header--scrolled');
      }

  });

  // Sliders
  $('.kitchen-slider__wrapper').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $('.kitchen-slider .pages').text( ((i < 10) ? '0' : '') + i + ' / ' + ( slick.slideCount < 10 ? '0' : '' ) + slick.slideCount );
  });

  $('.kitchen-slider__wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: $('.kitchen-slider .next'),
    prevArrow: $('.kitchen-slider .prev'),
    infinite: false,
  });

  $('.bathroom-slider__wrapper').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $('.bathroom-slider .pages').text( ((i < 10) ? '0' : '') + i + ' / ' + ( slick.slideCount < 10 ? '0' : '' ) + slick.slideCount );
  });

  $('.bathroom-slider__wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: $('.bathroom-slider .next'),
    prevArrow: $('.bathroom-slider .prev'),
    infinite: false,
  });

  // Reservation form
  $('#date-from').datepicker({
    minDate: 0,
    dateFormat: 'dd-mm-yy',
    ignoreReadonly: true,
    beforeShowDay: function (date) {
      var string = $.datepicker.formatDate('dd-mm-yy', date);
      return [excluded_days.indexOf(string) == -1]
    },
    onSelect: function (date) {
      var dateTo = $('#date-to');
      var startDate = $(this).datepicker('getDate');
      if ( (dateTo >= startDate) || ( dateTo.val().length == 0 ) ) {
        dateTo.datepicker('setDate', startDate);
        dateTo.attr('value', date);
      }
      startDate.setDate(startDate.getDate() + 2);
      dateTo.datepicker( 'option','minDate', startDate );
      $(this).attr('value', date);
    }
  });

  $('#date-to').datepicker({
    dateFormat: 'dd-mm-yy',
    minDate: 0,
    ignoreReadonly: true,
    beforeShowDay: function (date) {
      var string = $.datepicker.formatDate('dd-mm-yy', date);
      return [ (excluded_days.indexOf(string) == -1) ]
    },
    onSelect: function (date) {
      $(this).attr('value', date);
    }
  });

  if ( translates.iclCode == 'pl' ) {
    ( function( factory ) {
      if ( typeof define === "function" && define.amd ) {

        define( [ "../widgets/datepicker" ], factory );
      } else {

        factory( jQuery.datepicker );
      }
    }( function( datepicker ) {

    datepicker.regional.pl = {
      closeText: "Zamknij",
      prevText: "Poprzedni miesiąc",
      nextText: "Następny miesiąc",
      currentText: "Dziś",
      monthNames: [ "Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec",
      "Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień" ],
      monthNamesShort: [ "Sty","Lu","Mar","Kw","Maj","Cze",
      "Lip","Sie","Wrz","Pa","Lis","Gru" ],
      dayNames: [ "Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota" ],
      dayNamesShort: [ "Nie","Pn","Wt","Śr","Czw","Pt","So" ],
      dayNamesMin: [ "N","Pn","Wt","Śr","Cz","Pt","So" ],
      weekHeader: "Tydz",
      dateFormat: "dd.mm.yy",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: "" };
    datepicker.setDefaults( datepicker.regional.pl );

    return datepicker.regional.pl;

    } ) );
  }

  $('#mobileBurger').on('click', function() {
    $(this).toggleClass('mobile-burger--active');
    $('.page-header__wrapper').toggleClass('page-header__wrapper--active');
  });

  // Add/remove clients number in form
  $('.reservation__table .add').on('click', function() {
    var value = $('.reservation__table #clients').val();
    var result = parseInt(value) + 1;
    if ( result < 9 ) {
      $('.reservation__table #clients').val( result.toString() );
    }
  });

  $('.reservation__table .remove').on('click', function() {
    var value = $('.reservation__table #clients').val();
    var result = parseInt(value) - 1;
    if ( result > 0 ) {
      $('.reservation__table #clients').val( result.toString() );
    }
  });

  // AJAX call when change house - small form
  $('.reservation-form select, .reservation__form select').on('change', function() {
    var ajax = $('.ajax-form').attr('action-data');
    if ( ajax == null ) {
      ajax = $('.reservation__form').attr('action-data');
    }

    $.ajax({
      url: ajax,
      type: 'POST',
      data: {
        'action': 'updateDates',
        'house': $(this).val(),
      },
      beforeSend: function() {
        $('.loader').css('display', 'flex');
      },
      success: function(dates) {
        $('#date-from').datepicker('destroy');
        $('#date-from').datepicker({
          minDate: 0,
          dateFormat: 'dd-mm-yy',
          beforeShowDay: function (date) {
            var string = $.datepicker.formatDate('dd-mm-yy', date);
            return [dates.indexOf(string) == -1]
          },
          onSelect: function (date) {
            var dateTo = $('#date-to');
            var startDate = $(this).datepicker('getDate');
            dateTo.datepicker('setDate', startDate);
            startDate.setDate(startDate.getDate() + 2);
            dateTo.datepicker('option','minDate', startDate);
            $(this).attr('value', date);
            dateTo.attr('value', date);
          }
        });

        $('#date-from').datepicker('setDate', null);

        $('#date-to').datepicker('destroy');
        $('#date-to').datepicker({
          dateFormat: 'dd-mm-yy',
          minDate: 0,
          beforeShowDay: function (date) {
            var string = $.datepicker.formatDate('dd-mm-yy', date);
            return [dates.indexOf(string) == -1]
          },
          onSelect: function (date) {
            $(this).attr('value', date);
          }
        });

        $('#date-to').datepicker('setDate', null);
        $('.loader').css('display', 'none');
      },
      error: function(err) {
        console.log(err);
      }
    })
  });

  // Set today date in reservation form hidden input
  if ( $('#today').length > 0 ) {
    $('#today').val(new Date().toLocaleDateString('pl'));
  }

});